import { translateFn } from '../../../../utils/translator.helper';
import { AssetType } from '../../easmScanConfigurationAssetGrid/types';

export interface AssetTypeOption {
  title: string;
  value: number;
}

export function getAssetTypeValues(): Array<AssetTypeOption> {
  return [
    {
      title: translateFn('IPv4'),
      value: AssetType.IPv4,
    },
    {
      title: translateFn('IPv6'),
      value: AssetType.IPv6,
    },
    {
      title: translateFn('Email'),
      value: AssetType.EMAIL,
    },
    {
      title: translateFn('Domain'),
      value: AssetType.DOMAIN,
    },
  ];
}
